import script from "./TheRefusedOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./TheRefusedOrders.vue?vue&type=script&setup=true&lang=js"

import "./TheRefusedOrders.vue?vue&type=style&index=0&id=398f82d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-398f82d4"]])

export default __exports__